import { useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { debounce } from 'lodash'

import { ApplicationState } from '@/state/root.models'
import { walletsSelector } from '@/state/wallets/slices/index.slices'
import { WalletFilters } from '@/state/wallets/models'

import initialState from '@/state/wallets/slices/initial-state'
import { useWalletsActions } from './use-wallets-actions.hook'

export const useWalletsFilters = () => {
  const { getAllWallets, setWalletsFilters } = useWalletsActions()

  const { playerCard } = useSelector(
    ({ playerCard }: ApplicationState) => playerCard,
  )
  const { filters, pagination } = useSelector(walletsSelector)

  // eslint-disable-next-line
  const filterDelay = useCallback(
    debounce((newFilters: Partial<WalletFilters>) => {
      getAllWallets(newFilters)
    }, 1000),
    [],
  )

  const handleChangeSearch = (
    newFilter: Partial<WalletFilters>,
    debounce?: boolean,
  ) => {
    const newFilters = {
      ...filters,
      ...newFilter,
      page: 1,
    }

    setWalletsFilters(newFilters)

    if (debounce) {
      filterDelay(newFilters)
    } else {
      getAllWallets(newFilters)
    }
  }

  const handleChangePage = (newPage: number) => {
    setWalletsFilters({ ...filters, page: newPage })
    getAllWallets({ ...filters, page: newPage })
  }

  const handleChangeLimit = (newLimit: number) => {
    if (Math.ceil(pagination.total / newLimit) < (filters.page || 1)) {
      setWalletsFilters({
        ...filters,
        limit: newLimit,
        page: 1,
      })
      getAllWallets({ ...filters, limit: newLimit, page: 1 })
    } else {
      setWalletsFilters({ ...filters, limit: newLimit })
      getAllWallets({ ...filters, limit: newLimit })
    }
  }

  useEffect(() => {
    if (playerCard?.id) {
      setWalletsFilters({
        ...initialState.filters,
        playerId: playerCard?.id,
      })
      getAllWallets({ ...initialState.filters, playerId: playerCard?.id })
    }
  }, [playerCard]) // eslint-disable-line

  return {
    filters,
    handleChangeSearch,
    handleChangePage,
    handleChangeLimit,
  }
}
